/* ============================================================
   ELGÄ — INCIPIT STUDIO
   Global JS : reveal on scroll (entrée/sortie), header,
   drawer mobile, accordéons, carrousel, carte hero, buy now
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Titres blur (reveal mot à mot, joué une seule fois) ---------- */
  /* Contrairement à [data-elga-reveal], pas de rejeu à la sortie du
     viewport : l'animation se joue une fois puis le titre reste stable. */
  function initBlurTitles() {
    var els = document.querySelectorAll('[data-elga-blur-title]');
    if (!els.length) return;
 
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-inview'); });
      return;
    }
 
    els.forEach(function (el) {
      if (el.dataset.blurInit === 'true') return;
      el.dataset.blurInit = 'true';
 
      // Arme les états cachés (uniquement maintenant que le JS est là).
      el.classList.add('is-armed');
 
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-inview');
            io.unobserve(entry.target);
          });
        },
        { threshold: 0.3, rootMargin: '0px 0px -8% 0px' }
      );
      io.observe(el);
    });
  }

  /* ---------- Reveal on scroll (entrée seule, joué une fois) ---------- */
  function initReveals() {
    var els = document.querySelectorAll('[data-elga-reveal]');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('is-inview'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-inview');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -4% 0px' }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Marquee annonce : défilement continu garanti ----------
     Duplique les groupes jusqu'à couvrir 2× la largeur d'écran et
     cale le décalage de l'animation sur la largeur réelle d'un
     groupe : plus de bandeau figé ou de trous quand le texte est
     plus court que l'écran. */
  function initAnnounceMarquee() {
    document.querySelectorAll('[data-elga-marquee]').forEach(function (inner) {
      var group = inner.querySelector('.elga-announce__group');
      if (!group) return;

      var measure = function () {
        var groupW = group.getBoundingClientRect().width;
        if (!groupW) return;
        var needed = Math.max(2, Math.ceil((window.innerWidth * 2) / groupW) + 1);
        var current = inner.querySelectorAll('.elga-announce__group').length;
        for (var i = current; i < needed; i++) {
          var clone = group.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a').forEach(function (a) { a.tabIndex = -1; });
          inner.appendChild(clone);
        }
        inner.style.setProperty('--elga-marquee-shift', '-' + groupW + 'px');
      };

      measure();
      window.addEventListener('resize', measure);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    });
  }

  /* ---------- Header : ombre au scroll + hauteur en variable CSS ---------- */
  function initHeader() {
    var header = document.querySelector('.elga-header');
    if (!header) return;
    var setH = function () {
      document.documentElement.style.setProperty('--elga-header-h', header.offsetHeight + 'px');
    };
    setH();
    window.addEventListener('resize', setH);
    /* Desktop : la page défile dans .page-wrapper (html/body sont
       overflow:hidden, cf. base.css) — window.scrollY reste à 0 et
       ses événements scroll ne remontent pas jusqu'à window. */
    var pw = document.querySelector('.page-wrapper');
    var pageY = function () {
      return window.scrollY || (pw ? pw.scrollTop : 0);
    };
    var onScroll = function () {
      header.classList.toggle('is-scrolled', pageY() > 10);
    };
    onScroll();
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  }

  /* ---------- Drawer mobile ---------- */
  function initDrawer() {
    var drawer = document.querySelector('[data-elga-drawer]');
    if (!drawer) return;
    var open = function () {
      drawer.classList.add('is-open');
      /* scroll-lock : base.css gèle html ET .page-wrapper (scroller desktop) */
      document.documentElement.setAttribute('scroll-lock', '');
      if (window.elgaLenis) window.elgaLenis.stop();
    };
    var close = function () {
      drawer.classList.remove('is-open');
      document.documentElement.removeAttribute('scroll-lock');
      if (window.elgaLenis) window.elgaLenis.start();
    };
    document.querySelectorAll('[data-elga-drawer-open]').forEach(function (b) {
      b.addEventListener('click', open);
    });
    drawer.querySelectorAll('[data-elga-drawer-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* ---------- Accordéons (FAQ + fiche produit) ---------- */
  function initAccordions() {
    document.querySelectorAll('[data-elga-acc]').forEach(function (item) {
      var btn = item.querySelector('[data-elga-acc-btn]');
      var panel = item.querySelector('[data-elga-acc-panel]');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        // ferme les frères dans le même groupe
        var group = item.closest('[data-elga-acc-group]');
        if (group && !isOpen) {
          group.querySelectorAll('[data-elga-acc].is-open').forEach(function (other) {
            other.classList.remove('is-open');
            var p = other.querySelector('[data-elga-acc-panel]');
            if (p) p.style.maxHeight = '0px';
            var b = other.querySelector('[data-elga-acc-btn]');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
        }
        item.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
        panel.style.maxHeight = !isOpen ? panel.scrollHeight + 'px' : '0px';
      });
    });
  }

  /* ---------- Carrousel témoignages (scroll-snap + flèches) ---------- */
  function initCarousels() {
    document.querySelectorAll('[data-elga-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-elga-carousel-track]');
      var prev = root.querySelector('[data-elga-carousel-prev]');
      var next = root.querySelector('[data-elga-carousel-next]');
      if (!track) return;
      var step = function () {
        var card = track.firstElementChild;
        if (!card) return 0;
        var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      };
      var update = function () {
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      };
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Carte flottante du hero (fermeture mémorisée + vidéo hover) ---------- */
  function initHeroCard() {
    var HAS_HOVER = window.matchMedia('(hover: hover)').matches;
    var IN_EDITOR = typeof window.Shopify !== 'undefined' && window.Shopify.designMode;
    var KEY = 'elga-hero-card-dismissed';
 
    document.querySelectorAll('[data-elga-hero-card]').forEach(function (card) {
      if (card.dataset.cardInit === 'true') return;
      card.dataset.cardInit = 'true';
 
      /* Fermeture mémorisée (ignorée dans l'éditeur pour ne pas
         perdre la carte pendant les réglages). */
      if (!IN_EDITOR) {
        try {
          if (sessionStorage.getItem(KEY) === '1') card.classList.add('is-dismissed');
        } catch (e) { /* stockage indisponible */ }
      }
      var close = card.querySelector('[data-elga-hero-card-close]');
      if (close) {
        close.addEventListener('click', function () {
          card.classList.add('is-dismissed');
          try { sessionStorage.setItem(KEY, '1'); } catch (e) { /* noop */ }
        });
      }
 
      /* Vidéo au survol : loop muet, fondu 450ms. Sur tactile
         (pas de hover), lecture quand la carte est visible. */
      var media = card.querySelector('[data-elga-card-media]');
      if (!media) return;
      var video = media.querySelector('video');
      if (!video) return;
 
      video.muted = true;
      video.loop = true;
      video.setAttribute('playsinline', '');
 
      var play = function () {
        media.classList.add('is-playing');
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      };
      var stop = function (reset) {
        media.classList.remove('is-playing');
        setTimeout(function () {
          if (!media.classList.contains('is-playing')) {
            video.pause();
            if (reset) video.currentTime = 0;
          }
        }, 450);
      };
 
      if (HAS_HOVER) {
        media.addEventListener('mouseenter', play);
        media.addEventListener('mouseleave', function () { stop(true); });
      } else if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              entry.isIntersecting ? play() : stop(false);
            });
          },
          { threshold: 0.3 }
        );
        io.observe(media);
      } else {
        play();
      }
    });
  }
 
  /* ---------- Preloader du hero ---------- */
  /* L'état .is-preloading est posé par le script inline de la section
     (avant le premier paint). Ici on orchestre la séquence :
     reveal des mots → pause → sortie → nettoyage. */
  function initHeroPreloader() {
    document.querySelectorAll('[data-elga-hero].is-preloading').forEach(function (root) {
      if (root.dataset.preInit === 'true') return;
      root.dataset.preInit = 'true';
 
      var words = root.querySelectorAll('.elga-word');
      var duration = parseInt(root.dataset.preDuration, 10) || 700;
      var stagger = parseInt(root.dataset.preStagger, 10) || 90;
      var hold = parseInt(root.dataset.preHold, 10) || 350;
      var exit = parseInt(root.dataset.preExit, 10) || 550;
 
      var done = false;
      function cleanup() {
        if (done) return;
        done = true;
        root.classList.remove('is-preloading', 'is-exiting', 'is-revealed');
        root.classList.add('preloader-done');
        document.documentElement.classList.remove('elga-lock', 'elga-pre-exit');
        if (root.dataset.preOnce === 'true') {
          try { sessionStorage.setItem(root.dataset.preKey, '1'); } catch (e) { /* noop */ }
        }
      }
 
      function start() {
        // Double rAF : l'état initial (mots floutés, titre décalé)
        // est peint avant de déclencher les transitions.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            root.classList.add('is-revealed');
            var revealTotal = duration + stagger * Math.max(words.length - 1, 0);
            setTimeout(function () {
              root.classList.add('is-exiting');
              /* Le header entre dès le début de la sortie du voile
                 (au-dessus de celui-ci), avant les textes de la hero. */
              document.documentElement.classList.add('elga-pre-exit');
              setTimeout(cleanup, exit * 1.3 + 100);
            }, revealTotal + hold);
          });
        });
      }
 
      // Attend les fonts (largeur du titre stable) sans jamais
      // bloquer plus de 800ms.
      var started = false;
      function startOnce() {
        if (started) return;
        started = true;
        start();
      }
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(startOnce);
      }
      setTimeout(startOnce, 800);
 
      // Filet de sécurité absolu : jamais plus de 8s de voile.
      setTimeout(cleanup, 8000);
    });
  }


  /* ---------- Panier latéral (style Nayar) ---------- */
  /* Ajout / quantités / suppression via l'AJAX Cart API ; le
     contenu du panneau est re-rendu par la Section Rendering
     API (section elga-cart-drawer) pour rester fidèle au Liquid. */
  var elgaCart = (function () {
    var SECTION_ID = 'elga-cart-drawer';
    var root = function () {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    };
    var el = function () { return document.querySelector('[data-elga-cart]'); };

    function open() {
      var cart = el();
      if (!cart) return;
      cart.classList.add('is-open');
      /* scroll-lock : base.css gèle html ET .page-wrapper (scroller desktop) */
      document.documentElement.setAttribute('scroll-lock', '');
      if (window.elgaLenis) window.elgaLenis.stop();
    }
    function close() {
      var cart = el();
      if (!cart) return;
      cart.classList.remove('is-open');
      document.documentElement.removeAttribute('scroll-lock');
      if (window.elgaLenis) window.elgaLenis.start();
    }
    function setLoading(on) {
      var cart = el();
      if (cart) cart.classList.toggle('is-loading', on);
    }

    /* Remplace le contenu du panneau + synchronise la pastille header */
    function renderSection(html) {
      var cart = el();
      if (!cart || !html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-elga-cart]');
      if (!fresh) return;
      var inner = cart.querySelector('[data-elga-cart-inner]');
      var freshInner = fresh.querySelector('[data-elga-cart-inner]');
      if (inner && freshInner) inner.innerHTML = freshInner.innerHTML;
      var count = parseInt(fresh.getAttribute('data-count'), 10) || 0;
      cart.setAttribute('data-count', String(count));
      document.querySelectorAll('[data-elga-cart-count]').forEach(function (badge) {
        badge.textContent = String(count);
        badge.hidden = count === 0;
      });
    }

    function refresh() {
      return fetch(root() + '?sections=' + SECTION_ID)
        .then(function (r) { return r.json(); })
        .then(function (data) { renderSection(data[SECTION_ID]); })
        .catch(function () {});
    }

    function add(variantId, quantity) {
      setLoading(true);
      return fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: quantity || 1 }],
          sections: SECTION_ID
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function (data) {
          if (data.sections && data.sections[SECTION_ID]) renderSection(data.sections[SECTION_ID]);
          else return refresh();
        })
        .finally(function () { setLoading(false); });
    }

    function change(line, quantity) {
      setLoading(true);
      return fetch(root() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity), sections: SECTION_ID })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('change failed');
          return r.json();
        })
        .then(function (data) {
          if (data.sections && data.sections[SECTION_ID]) renderSection(data.sections[SECTION_ID]);
          else return refresh();
        })
        .finally(function () { setLoading(false); });
    }

    /* Remplace la liste complète des codes promo du panier
       (champ « discount » de /cart/update.js) puis re-rend le
       drawer avec la section renvoyée dans la même réponse. */
    function setDiscounts(codes) {
      setLoading(true);
      return fetch(root() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: codes.join(','), sections: SECTION_ID })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('discount update failed');
          return r.json();
        })
        .then(function (data) {
          if (data.sections && data.sections[SECTION_ID]) renderSection(data.sections[SECTION_ID]);
          return data;
        })
        .finally(function () { setLoading(false); });
    }

    return {
      open: open,
      close: close,
      add: add,
      change: change,
      refresh: refresh,
      setDiscounts: setDiscounts
    };
  })();

  function initCartDrawer() {
    var cart = document.querySelector('[data-elga-cart]');
    if (!cart || cart.dataset.cartInit === 'true') return;
    cart.dataset.cartInit = 'true';

    /* Ouverture depuis le header (le lien /cart reste le repli sans JS) */
    document.querySelectorAll('[data-elga-cart-open]').forEach(function (opener) {
      opener.addEventListener('click', function (e) {
        e.preventDefault();
        elgaCart.open();
      });
    });

    /* Fermetures + quantités : délégation (le contenu est re-rendu) */
    cart.addEventListener('click', function (e) {
      if (e.target.closest('[data-elga-cart-close]')) {
        elgaCart.close();
        return;
      }
      var qtyBtn = e.target.closest('[data-elga-cart-qty]');
      if (qtyBtn) {
        elgaCart.change(qtyBtn.getAttribute('data-line'), qtyBtn.getAttribute('data-qty'));
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') elgaCart.close();
    });
  }

  /* ---------- Sélecteur de quantité (fiche produit) ---------- */
  function initQtySelectors() {
    document.querySelectorAll('[data-elga-qty]').forEach(function (box) {
      if (box.dataset.qtyInit === 'true') return;
      box.dataset.qtyInit = 'true';
      var input = box.querySelector('[data-elga-qty-input]');
      var minus = box.querySelector('[data-elga-qty-minus]');
      var plus = box.querySelector('[data-elga-qty-plus]');
      if (!input) return;
      var clamp = function (v) {
        var max = parseInt(input.max, 10) || 99;
        return Math.min(max, Math.max(1, v));
      };
      if (minus) minus.addEventListener('click', function () {
        input.value = clamp((parseInt(input.value, 10) || 1) - 1);
      });
      if (plus) plus.addEventListener('click', function () {
        input.value = clamp((parseInt(input.value, 10) || 1) + 1);
      });
      input.addEventListener('change', function () {
        input.value = clamp(parseInt(input.value, 10) || 1);
      });
    });
  }

  /* ---------- Ajout au panier (fiche produit) ---------- */
  function initAddToCart() {
    document.querySelectorAll('[data-elga-add-to-cart]').forEach(function (btn) {
      if (btn.dataset.atcInit === 'true') return;
      btn.dataset.atcInit = 'true';
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        var qtyInput = document.querySelector('[data-elga-qty-input]');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
        elgaCart
          .add(variantId, qty)
          .then(function () { elgaCart.open(); })
          .catch(function () {
            // Repli sans AJAX : permalien panier
            window.location.href = '/cart/' + variantId + ':' + qty;
          })
          .finally(function () {
            btn.removeAttribute('aria-busy');
            btn.disabled = false;
          });
      });
    });
  }

  /* ---------- Page panier : quantités via le formulaire /cart ---------- */
  function initCartPage() {
    var form = document.querySelector('[data-elga-cartp]');
    if (!form || form.dataset.cartpInit === 'true') return;
    form.dataset.cartpInit = 'true';

    var submit = function () {
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    };

    form.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-elga-cartp-minus]');
      var plus = e.target.closest('[data-elga-cartp-plus]');
      var remove = e.target.closest('[data-elga-cartp-remove]');
      if (!minus && !plus && !remove) return;

      var row = e.target.closest('.elga-cartp__row');
      var input = row && row.querySelector('[data-elga-cartp-input]');
      if (!input) return;

      var qty = parseInt(input.value, 10) || 0;
      if (minus) qty = Math.max(0, qty - 1);
      if (plus) qty = Math.min(99, qty + 1);
      if (remove) qty = 0;
      input.value = qty;
      submit();
    });

    form.querySelectorAll('[data-elga-cartp-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var qty = parseInt(input.value, 10);
        input.value = isNaN(qty) ? 1 : Math.min(99, Math.max(0, qty));
        submit();
      });
    });
  }

  /* ---------- Codes promo (drawer + page panier) ---------- */
  /* Un code est validé côté Shopify : après /cart/update.js on
     vérifie discount_codes[].applicable ; si le code est refusé
     on le retire aussitôt et on affiche l'erreur. Sur la page
     panier, un succès recharge la page pour rafraîchir les totaux
     rendus en Liquid. */
  function initDiscounts() {
    if (document.documentElement.dataset.discountInit === 'true') return;
    document.documentElement.dataset.discountInit = 'true';

    var boxSelector = function (inDrawer) {
      return inDrawer
        ? '[data-elga-cart] [data-elga-discount]'
        : '[data-elga-cartp] [data-elga-discount]';
    };

    var codesFrom = function (box) {
      var raw = (box && box.getAttribute('data-codes')) || '';
      return raw.split(',').filter(Boolean);
    };

    /* Le drawer est re-rendu pendant l'opération : on re-cherche
       la boîte avant d'afficher l'erreur / restaurer la saisie. */
    var fail = function (inDrawer, code, message) {
      var box = document.querySelector(boxSelector(inDrawer)) ||
        document.querySelector('[data-elga-discount]');
      if (!box) return;
      var error = box.querySelector('[data-elga-discount-error]');
      var input = box.querySelector('[data-elga-discount-input]');
      if (error) {
        error.textContent = message;
        error.hidden = false;
      }
      if (input) {
        input.value = code;
        input.focus();
      }
    };

    var apply = function (box) {
      var input = box.querySelector('[data-elga-discount-input]');
      var code = input ? input.value.trim().toUpperCase() : '';
      if (!code) {
        if (input) input.focus();
        return;
      }

      var existing = codesFrom(box);
      if (existing.indexOf(code) !== -1) {
        input.value = '';
        return;
      }

      var inDrawer = !!box.closest('[data-elga-cart]');
      var onCartPage = !!document.querySelector('[data-elga-cartp]');
      box.classList.add('is-busy');

      elgaCart
        .setDiscounts(existing.concat(code))
        .then(function (cart) {
          var entry = null;
          (cart.discount_codes || []).forEach(function (c) {
            if (c.code && c.code.toUpperCase() === code) entry = c;
          });
          if (!entry || !entry.applicable) {
            return elgaCart.setDiscounts(existing).then(function () {
              fail(inDrawer, code, 'Ce code promo est invalide ou ne s’applique pas à votre panier.');
            });
          }
          if (onCartPage) window.location.reload();
        })
        .catch(function () {
          fail(inDrawer, code, 'Une erreur est survenue. Réessayez.');
        })
        .finally(function () {
          box.classList.remove('is-busy');
          var fresh = document.querySelector(boxSelector(inDrawer));
          if (fresh) fresh.classList.remove('is-busy');
        });
    };

    var remove = function (btn) {
      var box = btn.closest('[data-elga-discount]');
      if (!box) return;
      var code = (btn.getAttribute('data-code') || '').toUpperCase();
      var next = codesFrom(box).filter(function (c) {
        return c.toUpperCase() !== code;
      });
      var onCartPage = !!document.querySelector('[data-elga-cartp]');
      box.classList.add('is-busy');
      elgaCart
        .setDiscounts(next)
        .then(function () {
          if (onCartPage) window.location.reload();
        })
        .catch(function () {})
        .finally(function () {
          box.classList.remove('is-busy');
        });
    };

    document.addEventListener('click', function (e) {
      var applyBtn = e.target.closest('[data-elga-discount-apply]');
      if (applyBtn) {
        var box = applyBtn.closest('[data-elga-discount]');
        if (box) apply(box);
        return;
      }
      var removeBtn = e.target.closest('[data-elga-discount-remove]');
      if (removeBtn) remove(removeBtn);
    });

    /* Entrée dans le champ : appliquer sans soumettre le formulaire /cart */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var input = e.target.closest && e.target.closest('[data-elga-discount-input]');
      if (!input) return;
      e.preventDefault();
      var box = input.closest('[data-elga-discount]');
      if (box) apply(box);
    });
  }

  /* ---------- Galerie produit : dots du swipe mobile ---------- */
  function initProductGallery() {
    document.querySelectorAll('[data-elga-gallery]').forEach(function (gallery) {
      if (gallery.dataset.galleryInit === 'true') return;
      gallery.dataset.galleryInit = 'true';
      var track = gallery.querySelector('[data-elga-gallery-track]');
      var dotsWrap = gallery.querySelector('[data-elga-gallery-dots]');
      if (!track || !dotsWrap) return;
      var items = track.querySelectorAll('.elga-pmain__media-item');
      if (items.length < 2) return;

      var dots = [];
      items.forEach(function (item, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Image ' + (i + 1));
        if (i === 0) dot.classList.add('is-active');
        dot.addEventListener('click', function () {
          track.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });

      var setActive = function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        i = Math.min(dots.length - 1, Math.max(0, i));
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      };
      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(setActive);
      }, { passive: true });
    });
  }

  /* ---------- Section Réseaux : collage défilant en continu ---------- */
  /* Même mécanique que le marquee de l'annonce : on duplique le
     groupe jusqu'à couvrir 2× l'écran, puis on cale le décalage
     de l'animation sur la largeur réelle du groupe. La durée est
     déduite de la vitesse (px/s) du réglage → vitesse constante
     quel que soit le nombre d'images. */
  function initSocialMarquee() {
    document.querySelectorAll('[data-elga-social]').forEach(function (root) {
      if (root.dataset.socialInit === 'true') return;
      root.dataset.socialInit = 'true';
 
      var track = root.querySelector('[data-elga-social-track]');
      var group = root.querySelector('[data-elga-social-group]');
      if (!track || !group) return;
 
      var speed = parseInt(root.dataset.speed, 10) || 60; // px par seconde
 
      var measure = function () {
        var groupW = group.getBoundingClientRect().width;
        if (!groupW) return;
 
        // Duplique le groupe pour couvrir 2× la largeur d'écran.
        var needed = Math.max(2, Math.ceil((window.innerWidth * 2) / groupW) + 1);
        var current = track.querySelectorAll('[data-elga-social-group]').length;
        for (var i = current; i < needed; i++) {
          var clone = group.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
        }
 
        track.style.setProperty('--elga-marquee-shift', '-' + groupW + 'px');
        track.style.setProperty('--esoc-duration', groupW / speed + 's');
      };
 
      measure();
      window.addEventListener('resize', measure);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
 
      // Les images chargent en lazy : on re-mesure quand elles arrivent.
      root.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', measure, { once: true });
      });
    });

    /* ---------- Product Anatomy : roue de bienfaits ---------- */
  /* Mode "steps" : toutes les X secondes, la roue pivote pour
     amener le bienfait suivant au point focal (plein gauche,
     180°). La rotation cible = 180 − angle du point ; le CSS
     contre-rote les libellés de la même valeur avec la même
     durée/courbe → ils restent horizontaux pendant tout le
     mouvement. Le timer ne tourne que lorsque la section est
     visible à l'écran.
     Mode "spin" : rotation continue pilotée en pur CSS ; ici on
     se contente de la mettre en pause hors viewport.
     prefers-reduced-motion : roue statique, premier point actif. */
  function initAnatomy() {
    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 
    document.querySelectorAll('[data-elga-anatomy]').forEach(function (root) {
      if (root.dataset.anatInit === 'true') return;
      root.dataset.anatInit = 'true';
 
      var mode = root.dataset.mode || 'steps';
      var wheel = root.querySelector('[data-anat-wheel]');
      var points = root.querySelectorAll('[data-anat-point]');
      if (!wheel || !points.length) return;
 
      /* ----- Mode rotation continue : pause hors écran ----- */
      if (mode === 'spin') {
        if (!('IntersectionObserver' in window)) return;
        var ioSpin = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              root.classList.toggle('is-paused', !entry.isIntersecting);
            });
          },
          { threshold: 0.1 }
        );
        ioSpin.observe(root);
        return;
      }
 
      /* ----- Mode étapes ----- */
      var interval = parseInt(root.dataset.interval, 10) || 5000;
      var idx = 0;
      var timer = null;
 
      function setActive(i) {
        idx = i;
        var angle = parseFloat(points[i].dataset.angle) || 180;
        wheel.style.setProperty('--wheel', (180 - angle) + 'deg');
        points.forEach(function (p, j) {
          p.classList.toggle('is-active', j === i);
        });
      }
 
      function next() {
        setActive((idx + 1) % points.length);
      }
 
      // État initial : premier bienfait au point focal.
      setActive(0);
 
      // Statique si mouvement réduit, un seul point, ou pas d'IO.
      if (REDUCED || points.length < 2 || !('IntersectionObserver' in window)) return;
 
      function start() {
        if (timer) return;
        timer = setInterval(next, interval);
      }
      function stop() {
        if (!timer) return;
        clearInterval(timer);
        timer = null;
      }
 
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            entry.isIntersecting ? start() : stop();
          });
        },
        { threshold: 0.25 }
      );
      io.observe(root);
 
      // Nettoyage propre quand l'éditeur recharge la section.
      root.elgaAnatCleanup = function () {
        stop();
        io.disconnect();
      };
    });
  }
 
  /* Dans l'éditeur : coupe le timer de l'ancienne instance
     avant que la section soit re-rendue. À ajouter UNE fois,
     à côté de ton listener shopify:section:load existant : */
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-elga-anatomy]').forEach(function (root) {
      if (typeof root.elgaAnatCleanup === 'function') root.elgaAnatCleanup();
    });
  });

  }


  function initAll() {
    initReveals();
    initAnnounceMarquee();
    initHeader();
    initDrawer();
    initAccordions();
    initCarousels();
    initHeroCard();
    initHeroPreloader();
    initBlurTitles();
    initCartDrawer();
    initQtySelectors();
    initAddToCart();
    initProductGallery();
    initSocialMarquee();
    initCartPage();
    initAnatomy()
    initDiscounts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Ré-init dans l'éditeur de thème Shopify
  document.addEventListener('shopify:section:load', initAll);
})();